import { useMemo } from "react";
import React from "react";
import * as styles from "./HeaderContent.module.scss";
import { optimizeBackgroundImageUrl } from "utilities/contentful";
import { useDispatch, useIsMobile } from "hooks";
import { navigate } from "library";
import { setModal } from "utilities/UI/uiSlice";
import ReactPlayer from "react-player";

type ContentProps = {
  headerContent: Queries.ContentfulLandingPageHeaderContent;
};

const ContentfulVideo = ({ headerContent }: ContentProps) => {
  const dispatch = useDispatch();

  return (
    <div
      onClick={() =>
        headerContent.buttonUrl
          ? navigate(headerContent.buttonUrl)
          : dispatch(setModal("signUp"))
      }
      style={{ cursor: "pointer" }}
    >
      <ReactPlayer
        url={headerContent.backgroundImage?.file?.url}
        playing={true}
        loop={true}
        muted={true}
        width="100%"
        height="100%"
      />
    </div>
  );
};

const ContentfulImage = ({ headerContent }: ContentProps) => {
  const dispatch = useDispatch();
  const backgroundImageStyle = useMemo(
    () => ({
      width: "100%",
      backgroundImage: `${optimizeBackgroundImageUrl(
        headerContent.backgroundImage?.file?.url,
      )}`,
      aspectRatio:
        headerContent.backgroundImage?.file?.details.image?.width /
        headerContent.backgroundImage?.file?.details.image?.height,
    }),
    [headerContent],
  );

  return (
    <div
      style={backgroundImageStyle}
      className={styles.headerContent}
      onClick={() =>
        headerContent.buttonUrl
          ? navigate(headerContent.buttonUrl)
          : dispatch(setModal("signUp"))
      }
    />
  );
};

export const HeaderContent = ({ headerContent }: ContentProps) => {
  const isMobile = useIsMobile();

  // Determine the appropriate media based on device type
  const media =
    isMobile && headerContent.mobileBackgroundImage
      ? headerContent.mobileBackgroundImage
      : headerContent.backgroundImage;

  return media ? (
    media.file.contentType.includes("video") ? (
      <ContentfulVideo
        headerContent={{ ...headerContent, backgroundImage: media }}
      />
    ) : (
      <ContentfulImage
        headerContent={{ ...headerContent, backgroundImage: media }}
      />
    )
  ) : null;
};
